import * as angular from 'angular';
import { StateService } from '@uirouter/angularjs';

import { ComponentDefinition } from '../../models';
import { ButtonAction, ButtonWidget } from './button.widget';

class ButtonController implements angular.IComponentController {
    item: ButtonWidget;
    iconClass: string;
    isEditMode: boolean;

    private _watcher: (() => void);

    static $inject = ['$scope', '$state'];

    constructor(
        private _$scope: angular.IScope,
        private _$state: StateService
    ) {
    }

    $onInit() {
        // empty
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['item']?.currentValue) {
            this.refresh();
            if (this._watcher) {
                this._watcher();
            }
            this._watcher = this._$scope.$watch(() => this.item.configuration, () => this.refresh(), true);
        }
    }

    execute() {
        switch (this.item.configuration.action) {
            case ButtonAction.Redirect:
                this._$state.go(this.item.configuration.destination);
                break;
        }
    }

    private refresh() {
        const state = this._$state.get(this.item.configuration.destination);
        if (state?.data) {
            this.iconClass = state.data.icon;
        }
    }
}

export const wtButton: ComponentDefinition = {
    componentId: 'wtButton',
    controller: ButtonController,
    template: require('./button.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '<',
        isEditMode: '<'
    }
};